import clsx from 'clsx';
import { ReactNode } from 'react';

interface TitleProps {
  children: ReactNode;
  className?: string;
}

// @TODO: only isolated component, extend it - sizes, tag, style, etc.
export const Title = ({ children, className }: TitleProps) => {
  return <h1 className={clsx(className, 'font-normal text-content-gr4')}>{children}</h1>;
};
